export default "/images/getting_started.webp"